import { axiosInstance } from "@/axios/axiosInstance";
import { Product } from "@/types/product";
import { PaginatedResponse, QueryParamsBase } from "@/types/types";

export const getProducts = async (
  params?: QueryParamsBase & { select?: string[] },
): Promise<PaginatedResponse<Product>> => {
  const { data } = await axiosInstance.get("/v2/products", {
    params,
  });
  return data;
};

//store
export async function createProduct(values: Product) {
  const { data } = await axiosInstance.post(`/products`, values);
  return data;
}

//update
export async function updateProduct(values: Product) {
  const { data } = await axiosInstance.patch(`/products/${values.id}`, values);
  return data;
}

// recipe
import { Recipe } from "@/types/recipe";

export const getProductRecipe = async (productId: string): Promise<Recipe | null> => {
  const { data } = await axiosInstance.get(`/products/${productId}/recipe`);
  return data.data;
};

export interface RecipeIngredientPayload {
  ingredient_id: string;
  quantity: number;
}

export interface StoreRecipePayload {
  margin?: number | null;
  ingredients: RecipeIngredientPayload[];
}

export interface UpdateRecipePayload {
  version: number;
  margin?: number | null;
  ingredients: RecipeIngredientPayload[];
}

export const createProductRecipe = async (
  productId: string,
  payload: StoreRecipePayload
): Promise<Recipe> => {
  const { data } = await axiosInstance.post(`/products/${productId}/recipe`, payload);
  return data.data;
};

export const updateProductRecipe = async (
  productId: string,
  payload: UpdateRecipePayload
): Promise<Recipe> => {
  const { data } = await axiosInstance.put(`/products/${productId}/recipe`, payload);
  return data.data;
};

export const restockProduct = async (
  productId: string,
  quantity: number
): Promise<{ success: boolean; message: string }> => {
  const { data } = await axiosInstance.post(`/products/${productId}/restock`, { quantity });
  return data;
};


